<template>
  <div>
    <page-title
      isback
      :pageName="pageTitle"/>
    <div class='comm-container'>
      <div class='comm-page-container pd10'>
        <el-form
          style='width:600px;margin:0 auto;'
          ref='userInfoForm'
          :model='userInfoForm'
          label-position="left"
          label-width='100px'
          :rules='userInfoFormRule'>
          <el-form-item
            label='登录账号：'
            class='mt20'
            prop='userLoginName'>
            <el-input
              v-model.trim='userInfoForm.userLoginName'
              placeholder='请输入登录账号，6至20位'/>
          </el-form-item>
          <el-form-item
            label='登录密码：'
            class='mt20'
            prop='userInitPassword'>
            <el-input
             type="password"
              v-model.trim='userInfoForm.userInitPassword'
              placeholder='请输入登录密码，6至20位'/>
          </el-form-item>
          <el-form-item
            label='密码验证：'
            class='mt20'
            prop='loginPwdValid'>
            <el-input
             type="password"
              v-model.trim='userInfoForm.loginPwdValid'
              placeholder='请再次输入密码'/>
          </el-form-item>
          <el-form-item
            label='员工姓名：'
            class='mt20'
            prop='userName'>
            <el-input
              v-model.trim='userInfoForm.userName'
              placeholder='请输入员工姓名'/>
          </el-form-item>
          <el-form-item
            :label='userNameLabel'
            class='mt20'
            prop='userSex'>
            <el-radio-group v-model="userInfoForm.userSex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class='text-center'>
          <el-button
            class='plr20'
            type="primary"
            @click='submit'>提交</el-button>
          <el-button
            class='ml10 plr20'
            plain @click='resetForm'>重置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddGoods',
  data () {
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.userInfoForm.userInitPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      }
    return{
      userNameLabel:null,
      isStaff:null,
      pageTitle:'',
      userInfoForm:{
        userLoginName:null,
        userInitPassword:null,
        loginPwdValid:null,
        userName:null,
        userSex:''
      },
      userInfoFormRule:{
        userLoginName:[
          { required: true, message: '请输入', trigger: 'blur' },
          { min:6, max: 20, message: '6-20位', trigger: 'blur' }
        ],
        userInitPassword:[
          { required: true, message: '请输入', trigger: 'blur' },
          { min:6, max: 20, message: '6-20位', trigger: 'blur' }
        ],
        loginPwdValid:[
          { required: true, message: '请输入', trigger: 'blur' },
          { min:6, max: 20, message: '6-20位', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted(){
    this.isStaff = this.$route.query.isStaff
    this.isEdit = this.$route.query.isEdit
    if(this.isEdit){
      this.userInfoForm = JSON.parse(localStorage.getItem('userDetail'))
      this.userInfoForm.loginPwdValid = this.userInfoForm.userInitPassword
    }
    if(this.isStaff){
      this.pageTitle = this.isEdit ? '编辑员工信息' : '新增员工信息'
      this.userNameLabel ='员工姓名'
    }else{
      this.pageTitle = this.isEdit ? '编辑用户信息' : '新增用户信息'
      this.userNameLabel ='用户姓名'
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs.userInfoForm.resetFields();
    },
    submit () {
      this.$refs.userInfoForm.validate(valid => {
        if (valid) {
          let url ='',params = JSON.parse(JSON.stringify(this.userInfoForm))
          if(this.isEdit){
            url='user/updateUser'
          }else{
            url='user/insertUser'
            params.userType = this.isStaff ? 2 : 3
          }
          delete params.loginPwdValid
          console.log(params)
          this.$ajax({
            method:'post',
            url:url,
            data:params
          }).then(res => {
            if(res.data.code > 0){
              this.$message.success('保存成功！')
              let url =this.isStaff ? '/staff' : '/user'
              this.$router.push({
                path:url
              })
            }else{
              this.$message.warning(res.data.desc)
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
